export const OnlineOrderingSettingsToken = "OnlineOrderingSettings";
